import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { TrialModel } from './overview-model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  private readonly baseUrl = 'https://localhost.segestest.dk:5292/api/admin';
  private readonly baseUrl2 = `${environment.api.baseUrl}/api/admin/`;


  constructor(private http: HttpClient)
  { }

  getTrials(): Observable<TrialModel[]> {
    return this.http.get<TrialModel[]>(this.baseUrl);
  }

  getTrial(id: number): Observable<TrialModel> {
    console.log(`getTrial with id: ${id}`);
    const url = `${this.baseUrl}edittrial/${id}`;
    return this.http.get<TrialModel>(url);
    // return trialData;
  }

  attemptEndpoint(): Observable<string> {
    const url = `${this.baseUrl}/isalive_auth`;
    return this.http.get<string>(url);
  }
}



// To be deleted:
// const trialData: TrialModel =
// {
//   id: 1,
//   trialNumber: 1785,
//   // startDate: undefined,
//   // trialStatus: TrialStatus.Created,
//   repetitions: [
//     { batch: '1', section: 'K8', pen: '1', group: '1', feed: 'Kom 41' },
//     { batch: '1', section: 'K8', pen: '2', group: '2', feed: 'Kom 42' },
//     { batch: '1', section: 'K8', pen: '3', group: '1', feed: 'Kom 41' },
//     { batch: '1', section: 'K8', pen: '4', group: '3', feed: 'Kom 43' },
//     { batch: '2', section: 'K8', pen: '5', group: '2', feed: 'Kom 42' },
//     { batch: '2', section: 'K8', pen: '6', group: '1', feed: 'Kom 41' },
//     { batch: '2', section: 'K8', pen: '7', group: '3', feed: 'Kom 43' },
//     { batch: '2', section: 'K8', pen: '8', group: '1', feed: 'Kom 41' },
//     { batch: '3', section: 'K8', pen: '9', group: '2', feed: 'Kom 42' },
//     { batch: '3', section: 'K8', pen: '10', group: '1', feed: 'Kom 41' },
//     { batch: '3', section: 'K8', pen: '11', group: '3', feed: 'Kom 43' },
//     { batch: '3', section: 'K8', pen: '12', group: '1', feed: 'Kom 41' },
//     { batch: '4', section: 'K9', pen: '13', group: '1', feed: 'Kom 41' },
//     { batch: '4', section: 'K9', pen: '14', group: '3', feed: 'Kom 43' },
//     { batch: '4', section: 'K9', pen: '15', group: '1', feed: 'Kom 41' },
//     { batch: '4', section: 'K9', pen: '16', group: '2', feed: 'Kom 42' },
//     { batch: '5', section: 'K9', pen: '17', group: '1', feed: 'Kom 41' },
//     { batch: '5', section: 'K9', pen: '18', group: '2', feed: 'Kom 42' },
//     { batch: '5', section: 'K9', pen: '19', group: '1', feed: 'Kom 41' },
//     { batch: '5', section: 'K9', pen: '20', group: '3', feed: 'Kom 43' },
//     { batch: '6', section: 'K9', pen: '21', group: '1', feed: 'Kom 41' },
//     { batch: '6', section: 'K9', pen: '22', group: '3', feed: 'Kom 43' },
//     { batch: '6', section: 'K9', pen: '23', group: '2', feed: 'Kom 42' },
//     { batch: '6', section: 'K9', pen: '24', group: '1', feed: 'Kom 41' }
//   ]
// };
